import { makeStyles } from '@material-ui/core/styles';

const creditCardStyles = makeStyles((theme) => ({
  creditCardTitle: {
    color: theme.palette.blue1,
    fontFamily: theme.typography.proxima.semiBold,
    fontSize: theme.typography.pxToRem(16),
    LineHeight: theme.typography.pxToRem(19),
  },
  creditCardSubtitle: {
    color: theme.palette.gray1,
    lineHeight: theme.typography.pxToRem(19),
    marginTop: 10,
    marginBottom: 30,
  },
  cvvtooltip: {
    position: 'relative',
    flex: 1,

    '& .tooltip-icon': {
      position: 'absolute',
      left: '35px',
      top: '-2px',
      zIndex: 1,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 90,
      marginLeft: 10,
    },
  },
  tooltipContent: {
    maxWidth: '150px',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(19),
    color: theme.palette.grey1,

    '& .icon': {
      display: 'flex',
      flexDirection: 'column',
      textTransform: 'uppercase',
      textAlign: 'center',
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(8),
      lineHeight: '150%',
    },

    '& .icons-container': {
      display: 'flex',
      justifyContent: 'center',
      gap: '16px',
      paddingBottom: '10px',
    },
  },
  creditCardBalanceCharged: {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(19),
    marginTop: 30,
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  totalPaymentsHaveBeenMet: {
    color: theme.palette.green,
    fontFamily: theme.typography.proxima.semiBold,
    marginTop: 10,
    lineHeight: '20px',
  },
  AccordionPayment: {
    flexDirection: 'column',
  },
  noStyleButton: {
    color: theme.palette.blue2,
    padding: '0',
    minWidth: 'auto',
    minHeight: 'auto',
    width: 'auto',
    height: 'auto',
    '&:hover': {
      background: 'none',
    },
    '&:focus': {
      outline: 0,
      border: 0,
    },
    '& span': {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

export default creditCardStyles;
